import Input from 'lib/Input';
import usePendoTracking from 'customHooks/usePendoTracking';
import { FilterCreativeIdProps } from './FilterCreativeId.types';

const FilterCreativeId: React.FC<FilterCreativeIdProps> = ({ creativeId = '', changeFilters }) => {
  const { getPendoDataId } = usePendoTracking(window.location.pathname);

  return (
    <Input
      dataTestId="creative-id-input"
      name="creativeId"
      value={creativeId}
      placeholder="Creative ID"
      onChange={(value: string) => changeFilters({ creative: value })}
      dataPendoId={getPendoDataId('Creative ID filter')}
    />
  );
};

export default FilterCreativeId;
